import(/* webpackMode: "eager" */ "/app/node_modules/flag-icons/css/flag-icons.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-pdf/dist/esm/Page/AnnotationLayer.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-pdf/dist/esm/Page/TextLayer.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/cookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/notistackProvider.tsx");
